import { createAction, props } from '@ngrx/store';
import { IDeliveryAddressModel, IDeliveryData, IDeliveryModel } from '@partners/api';

export class DeliveryActions {
  static reset = createAction('[Delivery] Reset State');

  static loadTimeTable = createAction('[Delivery] Load Time Table');
  static loadTimeTableSuccess = createAction(
    '[Delivery] Load Time Table Success',
    props<{ model: IDeliveryAddressModel; data: IDeliveryData }>()
  );
  static loadTimeTableFailure = createAction('[Delivery] Load Time Table Failure', props<{ error: any }>());
  static load = createAction('[Delivery] Load');
  static loadSuccess = createAction('[Delivery] Load Success', props<{ model: IDeliveryModel; data: IDeliveryData }>());
  static loadFailure = createAction('[Delivery] Load Failure', props<{ error: any }>());
  static submit = createAction('[Delivery] Submit');
  static submitSuccess = createAction(
    '[Delivery] Submit Success',
    props<{ model: IDeliveryModel; data: IDeliveryData }>()
  );
  static submitFailure = createAction('[Delivery] Submit Failure', props<{ error: any }>());
}
